<script setup lang="ts">
interface IProps {
    imageComponent: Component;
    title?: string;
    description?: string;
}
const { imageComponent, title = '', description = '' } = defineProps<IProps>();
</script>

<template>
    <div class="advantage-item-container">
        <component :is="imageComponent" :alt="title" />
        <div class="details">
            <b>{{ title }}</b>
            <p>{{ description }}</p>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.advantage-item-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 12px;
    @include f-gap(12px, column);
    @include mobile-only {
        width: 202px;
    }
    img {
        width: 40px;
        height: 41px;
        object-fit: contain;
    }
    .details {
        b {
            @include tg-l($w7, usePalette($p-cool-gray, $p-800));
            text-align: center;
            display: block;
        }
        p {
            width: 252px;
            @include mobile-only {
                width: 178px;
            }
            @include tg-s($color: usePalette($p-cool-gray, $p-600));
            text-align: center;
            margin: 12px 0;
        }
    }
}
</style>
